import React, { useState } from "react";
import "./styles.css";

const HORARIOS_PADRAO = [
  "08:30", "09:30", "10:30",
  "11:30", "12:30", "13:30",
  "14:30", "15:30", "16:30"
];

// Simulação de horários ocupados (depois pode vir do backend)
const HORARIOS_OCUPADOS = ["09:30", "12:30"];

const Calendar = ({ menuConsulta }) => {
  const [servico, setServico] = useState("");
  const [data, setData] = useState("");
  const [horarioSelecionado, setHorarioSelecionado] = useState("");

  const selecionarHorario = (hora, ocupado) => {
    if (ocupado) return;
    setHorarioSelecionado(hora);
  };

  return (
    <div className="calendar-container">

      {/* SERVIÇO */}
      <label>Serviços Jurídicos</label>
      <select value={servico} onChange={(e) => setServico(e.target.value)}>
        <option value="">Selecione o serviço</option>
        {menuConsulta.map((item) => (
          <option key={item.id} value={item.titre}>
            {item.titre}
          </option>
        ))}
      </select>

      {/* DATA */}
      <label>Escolha uma data disponível:</label>
      <input
        type="date"
        value={data}
        onChange={(e) => setData(e.target.value)}
      />

      {/* HORÁRIOS */}
      <label>Escolha um horário disponível:</label>
      <div className="horarios">
        {HORARIOS_PADRAO.map((hora) => {
          const ocupado = HORARIOS_OCUPADOS.includes(hora);
          const selecionado = horarioSelecionado === hora;

          return (
            <div
              key={hora}
              className={`horario 
                ${ocupado ? "ocupado" : "livre"} 
                ${selecionado ? "selecionado" : ""}
              `}
              onClick={() => selecionarHorario(hora, ocupado)}
            >
              {hora}
            </div>
          );
        })}
      </div>

      {/* CONFIRMAR */}
      <button
        disabled={!servico || !data || !horarioSelecionado}
        onClick={() =>
          alert(
            `Consulta agendada:\n${servico}\n${data}\n${horarioSelecionado}`
          )
        }
      >
        Confirmar agendamento
      </button>
    </div>
  );
};

export default Calendar;
